/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChefEntrepriseSiegeSocialGridDto } from './ChefEntrepriseSiegeSocialGridDto';
import {
    ChefEntrepriseSiegeSocialGridDtoFromJSON,
    ChefEntrepriseSiegeSocialGridDtoFromJSONTyped,
    ChefEntrepriseSiegeSocialGridDtoToJSON,
} from './ChefEntrepriseSiegeSocialGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ChefEntrepriseSiegeSocialGridDtoPaginatedResults
 */
export interface ChefEntrepriseSiegeSocialGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSiegeSocialGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ChefEntrepriseSiegeSocialGridDto>}
     * @memberof ChefEntrepriseSiegeSocialGridDtoPaginatedResults
     */
    results?: Array<ChefEntrepriseSiegeSocialGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ChefEntrepriseSiegeSocialGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ChefEntrepriseSiegeSocialGridDtoPaginatedResults interface.
 */
export function instanceOfChefEntrepriseSiegeSocialGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseSiegeSocialGridDtoPaginatedResultsFromJSON(json: any): ChefEntrepriseSiegeSocialGridDtoPaginatedResults {
    return ChefEntrepriseSiegeSocialGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ChefEntrepriseSiegeSocialGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseSiegeSocialGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ChefEntrepriseSiegeSocialGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ChefEntrepriseSiegeSocialGridDtoPaginatedResultsToJSON(value?: ChefEntrepriseSiegeSocialGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ChefEntrepriseSiegeSocialGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

